import React from 'react';

const LoadingSpinner = ({ size = 'md', message = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24'
  };

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className={`inline-block animate-spin rounded-full border-t-2 border-b-2 ${sizeClasses[size]}`} style={{ borderColor: '#D4AF37' }}></div>
      {message && <p className="mt-4 text-gray-600 text-sm sm:text-base">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
